import { IInfiniteData } from '../../../../types';

import { IMissingInventoryListData } from '../../../types';

/**
 * Format the response of the inbound missing inventory list items.
 */
export function formatMissingInventoriesResponse(
  data: IInfiniteData<IMissingInventoryListData> | undefined
): IMissingInventoryListData {
  if (!data?.pages || data.pages.length === 0) {
    return {
      records: [],
      total: 0,
    };
  }

  let total = 0;

  const records = data.pages.flatMap((page) => {
    total = page?.total || 0;

    return page?.records || [];
  });

  return { records, total };
}
